import {
	API_DELETE_PATIENT,
	API_GET_ALL_PATIENT,
	API_PATCH_PATIENT,
	API_PATCH_PATIENT_FOLDERMANAGER,
	API_POST_PATIENT,
	API_SEARCH_PATIENT,
	API_GET_PATIENT_EXISTS,
	API_GET_PATIENT_MYLAB,
	API_GET_MATCHING_PATIENT,
	API_GET_MPI_PATIENT_BY_MATRICULE,
	API_POST_PATIENT_DOCUMENT,
	API_DELETE_PATIENT_DOCUMENT,
	API_GET_PATIENT_DOCUMENT,
	API_GET_PATIENT_IATA_QRCODE,
	API_GET_PATIENT_IATA_DID,
	API_CLEAR_PATIENT_IATA,
	API_GET_PATIENT_INVOICES,
	API_GET_PATIENT_DKV_STATUS,
	API_CLEAN_PATIENT_DKV_STATUS,
	API_GET_PATIENT_CASING_PAYMENTS,
	API_DELETE_PATIENT_CASING_PAYMENTS,
	API_PUT_PATIENT_CASING_PAYMENTS,
	RESET_INVOICES_FOR_PATIENT,
	API_GET_PATIENT,
} from "actions/patient";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_GET_ALL_PATIENT]: {
		default: "/patients",
		v2: "/patient",
		currentClient: DEFAULT_CLIENT,
	},
	[API_GET_PATIENT]: {
		default: (patientId) => `/patients/${patientId}`,
		v2: (patientId) => `/patient/${patientId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_POST_PATIENT]: {
		default: "/patients",
		v2: "/patient",
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_PATIENT]: {
		default: (patientId) => `/patients/${patientId}`,
		v2: (patientId) => `/patient/${patientId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PATCH_PATIENT_FOLDERMANAGER]: {
		default: (patientId) => `/patients/${patientId}`,
		v2: (patientId) => `/patient/${patientId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_DELETE_PATIENT]: {
		default: (patientId) => `/patients/${patientId}`,
		v2: (patientId) => `/patient/${patientId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_SEARCH_PATIENT]: {
		default: (size, start) => `patients/search/${size}/${start}`,
		v2: "/patient/search",
		currentClient: DEFAULT_CLIENT,
	},
	// Legacy casing payments endpoints (not implemented in v7 PaymentController)
	[API_GET_PATIENT_CASING_PAYMENTS]: {
		default: (externalId, centerId) => `/payments/casing/${externalId}/center/${centerId}`,
		v2: (externalId, centerId) => `/payments/casing/${externalId}/center/${centerId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_DELETE_PATIENT_CASING_PAYMENTS]: {
		default: (externalId) => `/payments/casing/${externalId}`,
		v2: (externalId) => `/payments/casing/${externalId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_PUT_PATIENT_CASING_PAYMENTS]: {
		default: (casingId) => `/payments/casing/${casingId}`,
		v2: (casingId) => `/payments/casing/${casingId}`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function getPatients() {
	const version = getVersion(API_GET_ALL_PATIENT);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_GET_ALL_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function getPatient(patientId) {
	const version = getVersion(API_GET_PATIENT);
	const url = typeof version.path === 'function' ? version.path(patientId) : version.path;
	return {
		type: API_GET_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
			},
		},
	};
}

export function postPatient(patient) {
	const version = getVersion(API_POST_PATIENT);
	const url = typeof version.path === 'function' ? version.path() : version.path;
	return {
		type: API_POST_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "POST",
				data: patient,
			},
		},
	};
}

export function patchPatient(patient, auto = false) {
	const version = getVersion(API_PATCH_PATIENT);
	const url = typeof version.path === 'function' ? version.path(patient.id) : version.path;
	return {
		type: API_PATCH_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: { ...patient, auto: auto },
			},
		},
	};
}

export function patchPatientFromFolderManager(patient, auto = false) {
	const version = getVersion(API_PATCH_PATIENT_FOLDERMANAGER);
	const url = typeof version.path === 'function' ? version.path(patient.id) : version.path;
	return {
		type: API_PATCH_PATIENT_FOLDERMANAGER,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "PATCH",
				data: { ...patient, auto: auto },
			},
		},
	};
}

export function deletePatient(patient) {
	const version = getVersion(API_DELETE_PATIENT);
	const url = typeof version.path === 'function' ? version.path(patient.id) : version.path;
	return {
		type: API_DELETE_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "DELETE",
			},
		},
	};
}

export function getMyLabPatientExists(myLabId) {
	return {
		type: API_GET_PATIENT_EXISTS,
		payload: {
			request: {
				url: `/patients/exists/${myLabId}/mylab`,
				method: "GET",
			},
		},
	};
}

export function searchPatientsMyLab(searchData, size, start) {
	const version = getVersion(API_SEARCH_PATIENT);
	
	if (version.currentClient === V2_CLIENT) {
		const url = typeof version.path === 'function' ? version.path() : version.path;
		return {
			type: API_SEARCH_PATIENT,
			payload: {
				client: version.currentClient,
				request: {
					url,
					method: "GET",
					params: {
						...searchData,
						page: start || 1,
						limit: size || 20,
					},
				},
			},
		};
	}
	
	const url = typeof version.path === 'function' ? version.path(size, start) : version.path;
	return {
		type: API_SEARCH_PATIENT,
		payload: {
			client: version.currentClient,
			request: {
				url,
				method: "GET",
				params: searchData,
			},
		},
	};
}

export function postPatientMyLab(patient) {
	return {
		type: API_POST_PATIENT,
		payload: {
			request: {
				url: `/patients/mylab`,
				method: "POST",
				data: patient,
			},
		},
	};
}

export function getMatchingPatient(service_id, external_id, query) {
	return {
		type: API_GET_MATCHING_PATIENT,
		payload: {
			request: {
				url: `/patients/matcher/${service_id}/${external_id}`,
				method: "GET",
				params: query,
			},
		},
	};
}

export function getInvoicesForPatient(external_id) {
	return {
		type: API_GET_PATIENT_INVOICES,
		payload: {
			request: {
				url: `/patient/${external_id}/invoices`,
				method: "GET",
			},
		},
	};
}
export function resetInvoicesForPatient() {
	return { type: RESET_INVOICES_FOR_PATIENT };
}

export function getCasingForPatient(external_id, centerId) {
	const version = getVersion(API_GET_PATIENT_CASING_PAYMENTS);
	const url = typeof version.path === 'function' ? version.path(external_id, centerId) : version.path;
	return {
		type: API_GET_PATIENT_CASING_PAYMENTS,
		payload: {
			request: {
				url,
				method: "GET",
			},
			client: version.currentClient,
		},
	};
}

export function cancelCasingForPatient(external_id) {
	const version = getVersion(API_DELETE_PATIENT_CASING_PAYMENTS);
	const url = typeof version.path === 'function' ? version.path(external_id) : version.path;
	return {
		type: API_DELETE_PATIENT_CASING_PAYMENTS,
		payload: {
			request: {
				url,
				method: "DELETE",
			},
			client: version.currentClient,
		},
	};
}
export function exportCasingForPatient(casing_id) {
	const version = getVersion(API_PUT_PATIENT_CASING_PAYMENTS);
	const url = typeof version.path === 'function' ? version.path(casing_id) : version.path;
	return {
		type: API_PUT_PATIENT_CASING_PAYMENTS,
		payload: {
			request: {
				url,
				method: "PUT",
			},
			client: version.currentClient,
		},
	};
}

export function getMpiPatientByMatricule(matricule) {
	return {
		type: API_GET_MPI_PATIENT_BY_MATRICULE,
		payload: {
			request: {
				url: `/mpi/patient`,
				method: "GET",
				params: {
					matricule,
				},
			},
		},
	};
}

export function addPatientDocument(patientId, data) {
	return {
		type: API_POST_PATIENT_DOCUMENT,
		payload: {
			request: {
				config: { headers: { "Content-Type": "multipart/form-data" } },
				url: `/patients/${patientId}/document`,
				method: "post",
				data: data,
			},
		},
	};
}

export function getPatientDocuments(patientId) {
	return {
		type: API_GET_PATIENT_DOCUMENT,
		payload: {
			request: {
				url: `/patients/${patientId}/document`,
			},
		},
	};
}

export function deletePatientDocument(documentId) {
	return {
		type: API_DELETE_PATIENT_DOCUMENT,
		payload: {
			request: {
				url: `/patients/documents/${documentId}`,
				method: "DELETE",
			},
		},
	};
}

export function getQRCodeIata(patientId) {
	return {
		type: API_GET_PATIENT_IATA_QRCODE,
		payload: {
			request: {
				url: `/patients/qriata/${patientId}`,
			},
		},
	};
}
export function getInfosIata(did, patientId) {
	return {
		type: API_GET_PATIENT_IATA_DID,
		payload: {
			request: {
				url: `/patients/${patientId}/iatadid/${did}`,
			},
		},
	};
}

export function getPatientMyLab(myLabPatientId) {
	return {
		type: API_GET_PATIENT_MYLAB,
		payload: {
			request: {
				url: `/mylab/patient/${myLabPatientId}`,
			},
		},
	};
}

export function clearIata(patientId) {
	return {
		type: API_CLEAR_PATIENT_IATA,
		payload: {
			request: {
				url: `/patients/cleaniata/${patientId}`,
				method: "DELETE",
			},
		},
	};
}

export function checkDKVStatus(patientId) {
	return {
		type: API_GET_PATIENT_DKV_STATUS,
		payload: {
			request: {
				url: `/dkv`,
				method: "GET",
				params: {
					patient: patientId,
				},
			},
		},
	};
}

export function cleanDkvStatus() {
	return {
		type: API_CLEAN_PATIENT_DKV_STATUS,
	};
}
